import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Checkbox,
  FormControlLabel,
  CircularProgress
} from "@material-ui/core";

const blue = "#0057FF";
const navy = "#010B36";

const display = value => {
  if (value === null || value === undefined || value === "") {
    return "Não informado";
  }
  return String(value);
};

export default function KoraxFormImportReviewDialog({
  open,
  rows,
  submitting,
  error,
  onCancel,
  onConfirm
}) {
  const [accepted, setAccepted] = useState(false);

  useEffect(() => {
    if (open) setAccepted(false);
  }, [open]);

  return (
    <Dialog
      open={Boolean(open)}
      onClose={submitting ? () => {} : onCancel}
      fullWidth
      maxWidth="sm"
      aria-labelledby="korax-import-review-title"
      PaperProps={{ style: { borderRadius: 15 } }}
    >
      <DialogTitle id="korax-import-review-title">
        <div style={{
          color: navy,
          fontWeight: 800,
          fontSize: 19
        }}>
          Revisar alterações
        </div>
        <div style={{
          fontSize: 12,
          color: "#64748B",
          marginTop: 6
        }}>
          Esta confirmação atualizará dados reais
          do cliente ou da oportunidade selecionada.
        </div>
      </DialogTitle>

      <DialogContent dividers>
        {rows.map((row, index) => (
          <div key={`${row.target}-${index}`} style={{
            border: "1px solid #E2E8F0",
            borderRadius: 10,
            padding: 14,
            marginBottom: 13
          }}>
            <div style={{
              color: blue,
              fontSize: 13,
              fontWeight: 800,
              marginBottom: 10
            }}>
              {row.title}
            </div>

            <div style={{
              fontSize: 11,
              color: "#64748B"
            }}>
              Valor atual
            </div>
            <div style={{
              fontSize: 13,
              padding: "8px 0",
              overflowWrap: "anywhere",
              whiteSpace: "pre-wrap"
            }}>
              {display(row.before)}
            </div>

            <div style={{
              fontSize: 11,
              color: "#64748B",
              marginTop: 6
            }}>
              Será substituído por
            </div>
            <div style={{
              background: "#EAF0FF",
              borderRadius: 7,
              padding: 10,
              fontSize: 13,
              fontWeight: 600,
              overflowWrap: "anywhere",
              whiteSpace: "pre-wrap"
            }}>
              {display(row.newValue)}
            </div>
          </div>
        ))}

        <FormControlLabel
          control={
            <Checkbox
              color="primary"
              checked={accepted}
              disabled={submitting}
              onChange={event => setAccepted(event.target.checked)}
            />
          }
          label={
            <span style={{ fontSize: 12 }}>
              Conferi os valores e autorizo a atualização
              dos {rows.length} campos selecionados.
            </span>
          }
        />

        {error && (
          <div role="alert" style={{
            color: "#B42318",
            fontSize: 12,
            padding: 12,
            background: "#FEF3F2",
            borderRadius: 8,
            marginTop: 8
          }}>
            {error}
          </div>
        )}
      </DialogContent>

      <DialogActions style={{
        padding: 16,
        display: "flex",
        flexWrap: "wrap",
        gap: 8
      }}>
        <Button
          onClick={onCancel}
          disabled={submitting}
          style={{ textTransform: "none" }}
        >
          Voltar e revisar
        </Button>

        <Button
          variant="contained"
          color="primary"
          disabled={!accepted || submitting || !rows.length}
          onClick={onConfirm}
          style={{
            background: accepted && !submitting ? blue : undefined,
            textTransform: "none",
            fontWeight: 800
          }}
        >
          {submitting ? (
            <>
              <CircularProgress size={16} style={{
                marginRight: 9,
                color: "#FFFFFF"
              }} />
              Importando...
            </>
          ) : "Confirmar importação"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
